import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition, query, keyframes, group } from '@angular/animations';
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";

declare var jquery: any;
declare var $: any;

@Component({
	selector: 'app-case-practice-authorization-main',
	animations: [
		// 页面载入动画效果
		trigger('casePracticeTeamAuthAnimation', [
			transition(':enter', [
				style({
					opacity: 0
				}),
			])
		]),
		trigger('noticeAnimation', [
			state('showNotice', style({
				opacity: 1,
				transform: 'translate(0%)'
			})),
			state('hideNotice', style({
				opacity: 0,
				transform: 'translate(-200%)'
			})),
			transition('hideNotice => showNotice', animate('200ms', keyframes([
				style({
					opacity: 0,
					transform: 'translate(-150%)'
				}),
				style({
					opacity: 0.2,
					transform: 'translate(-100%)'
				}),
				style({
					opacity: 0.4,
					transform: 'translate(-80%)'
				}),
				style({
					opacity: 0.6,
					transform: 'translate(-60%)'
				}),
				style({
					opacity: 0.8,
					transform: 'translate(-40%)'
				}),
				style({
					opacity: 1,
					transform: 'translate(0%)'
				}),
			]))),
			transition('showNotice => hideNotice', animate('200ms', style({
				opacity: 0
			})))
		]),
		trigger('optionWrapAnimation', [
			state('hideOptionWrap', style({
				transform: 'translate(-200%)',
				opacity: 0
			})),
			state('showOptionWrap', style({
				transform: 'translate(0%)',
				opacity: 1
			})),
			transition('hideOptionWrap => showOptionWrap', animate('600ms', keyframes([
				style({
					transform: 'translate(-100%)',
					opacity: 0.1
				}),
				style({
					transform: 'translate(-80%)',
					opacity: 0.1
				}),
				style({
					transform: 'translate(-60%)',
					opacity: 0.3
				}),
				style({
					transform: 'translate(-50%)',
					opacity: 0.4
				}),
				style({
					transform: 'translate(-40%)',
					opacity: 0.5
				}),
				style({
					transform: 'translate(-30%)',
					opacity: 0.55
				}),
				style({
					transform: 'translate(-20%)',
					opacity: 0.6
				}),
				style({
					transform: 'translate(-10%)',
					opacity: 0.8
				}),
				style({
					transform: 'translate(0%)',
					opacity: 1
				})
			])))
		]),
	],
	templateUrl: './case-practice-authorization-main.component.html',
	styleUrls: ['./case-practice-authorization-main.component.css']
})
export class CasePracticeAuthorizationMainComponent implements OnInit, AfterViewInit {

	questions: any;
	step: number;
	currentWord: string;
	currentFakeWord: string;
	currentHint: string;
	currentItem: any;
	currentRole: string;
	currentExpression: string;
	oldExpression: string;
	currentOptions: any;
	nextQuestionId: number;
	clickable: boolean;
	conversationHistory: any;
	oldItemTemp: any;
	itemTemp: any;
	optionsTemp: any;
	optionIndexTemp: any;
	oldOptionIndexTemp: number;
	nextQuestionIdTemp: number;
	currentCaseId: number;
	initMode: number;
	practiceId: number;
	exerciseId: number;
	learningPathId: number;
	import: string;
	noticeShow: boolean;
	optionWrapShow: boolean;
	msgCharacter: number;
	msgTimeout: any;

	optionClick: boolean; // 监听长按选项行为
	optionOnClick: boolean; // 监听用户是否按键
	optionClickTimeout: any; // 长按选项timeout

	taskBook: any;
	mode: number;
	discussionBgMainMode: number;
  assetsRoute: string = "../../assets";
  type: string;
	constructor(
		private commonService: CommonService,
		private apiService: ApiService,
		private route: ActivatedRoute,
		private router: Router
	) {}

	ngOnInit() {
		this.currentWord = "";
		this.noticeShow = false;
		this.optionWrapShow = false;
		this.msgCharacter = 0;
		this.msgTimeout = null;
		this.currentRole = "";
		this.optionClick = false;
		this.optionOnClick = false;
		this.optionClickTimeout = null;
		this.discussionBgMainMode = 0;
		this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    if(localStorage.getItem('sh')){
      this.type = 'huatek';
    }else{
      this.route.queryParams.subscribe(queryParams=>{
        this.type = queryParams['type'];
      })
    }

	}

	ngAfterViewInit() {
		this.commonService.initPage({
			'backgroundColor': 'white'
		});

		this.route.params.subscribe(params => {
			this.practiceId = params['practiceId'];
			this.exerciseId = params['exerciseId'];
			this.learningPathId = params['learningPathId'];

			this.apiService.ajax({
				'type': 'get',
				'url': '/api/exercises/' + this.exerciseId
			}).subscribe(result => {
				this.clickable = true;
				this.questions = result.questions;
				this.import = result.import;
				this.conversationHistory = [];
				this.currentCaseId = result.id;
				//全局变量初始化为 null
				window["exercises" + this.currentCaseId] = null;
				if(result.name == '协作') {
					this.mode = 2;
				} else {
					this.mode = 1;
				}
				this.exerciseInit();
			});

			this.apiService.ajax({
				'type': 'get',
				'url': '/api/taskBook/' + this.exerciseId
			}).subscribe(result => {
				this.taskBook = result;
			});

		});

		document.oncontextmenu = function(e) {
			e.preventDefault();
		}
	}

	exerciseInit() {

		let _this = this;
		this.currentFakeWord = "";
		this.msgCharacter = 0;
		this.itemTemp = this.questions[0];
		let roleTemp;
		if(this.mode == 1) {
			roleTemp = '高朗';
		} else {
			roleTemp = '方科科';
		}
		do {

			this.optionsTemp = this.itemTemp.options;
			this.optionIndexTemp = this.getSelectedOptionIndex(this.optionsTemp);
			if(this.optionIndexTemp != -1) {

				this.nextQuestionIdTemp = this.optionsTemp[this.optionIndexTemp].nextQuestionId;
				this.conversationHistory.push({
					'role': roleTemp,
					'comment': this.itemTemp.description
				});
				if(this.itemTemp.directorComment != '') {
					this.conversationHistory.push({
						'role': '导师点评',
						'comment': this.itemTemp.directorComment
					});
				}
				this.conversationHistory.push({
					'role': '我',
					'comment': this.optionsTemp[this.optionIndexTemp].description
				});
				this.setItemTemp(this.nextQuestionIdTemp);

			} else {

				break;

			}

		} while (true);

		if(this.conversationHistory.length != 0) {

			this.conversationHistory.unshift({
				'role': '我',
				'comment': this.import
			});
			this.step = 2.5;
			this.currentRole = "我";
			this.currentWord = this.oldItemTemp.options[this.oldOptionIndexTemp].description;
			this.currentFakeWord = this.currentWord;
			this.currentExpression = this.oldItemTemp.expression;
			this.currentItem = this.itemTemp;
			this.clickable = false;
			// console.log(this.currentExpression);
			// console.log($(this.getDomIdByExpression(this.currentExpression)));
			$(document).ready(function() {
				//$(_this.getDomIdByExpression(_this.currentExpression)).fadeIn(200);
				$('#talkBox1').fadeIn(200); //这两行有bug，不能正常显示，暂时搁置
				if(_this.mode == 1) {
					$('#reviewBtn').fadeIn(200);
				} else {
					$('#reviewBtn2').fadeIn(200);
				}

				setTimeout(function() {

					_this.getLetterByLetter($('#talkBoxContent1'));

				}, 500);

				setTimeout(function() {

					_this.clickable = true;

				}, 750);

			})

		} else {

			this.currentWord = this.import;
			this.currentFakeWord = this.currentWord;
			this.currentItem = this.questions[0];
			if(this.mode == 1) {
				this.currentExpression = '开心';
			} else {
				this.currentExpression = '正常';
			}

			// $('#notice').fadeIn(200);
			$(document).ready(function() {
				_this.noticeShow = true;
				if(_this.mode == 1) {
					$('#happy').fadeIn(200);
					_this.step = 0;
				} else {
					/*$('#common').fadeIn(200);*/
					_this.step = 11;
				}
			});

		}

	}

	/*  逻辑F
	  step 0: 初始化, 用户再次点击屏幕, => step 1
	  step 1: 显示我说的话, 再次点击 => step 2
	  step 2: 显示当前节点高朗说的话再次点击，如果有导师提示语 => step 3 如果没有导师提示语并有选项 => step 4 如果没有导师提示语并没有选项 => step 5
	  step 3: 显示导师提示语, 再次点击 如果有选项 => step 4 如果没有选项 => step 5
	  step 4: 显示选项, 点击选项后 => step 1
	  step 5; 决策树终止，显示生成报告按钮
	*/
	screenClick() {
		let _this = this;
		if(!this.clickable) {
			return;
		}

		this.msgCharacter = 0
		if(this.step == 0) {
			this.clickable = false;
			this.noticeShow = false;
			this.currentRole = "我";
			setTimeout(function() {
				_this.currentFakeWord = _this.currentWord;
				_this.showSelfTalk();
				$('#reviewBtn').fadeIn(200);
				setTimeout(function() {
					_this.getLetterByLetter($('#talkBoxContent1'));
					setTimeout(function() {
						_this.step = 2.5;
						_this.clickable = true;
					}, 1000);
				}, 250);
			}, 1000);
			this.conversationHistory.push({
				'role': '我',
				'comment': this.currentWord
			});
		} else if(this.step == 1) {
			this.clickable = false;
			this.oldExpression = this.currentExpression;
			this.currentExpression = this.currentItem.expression;
			this.closeSelfTalk();
			$('#talkBoxContent1').text("");
			if(this.oldExpression != this.currentExpression) {
				$(this.getDomIdByExpression(this.oldExpression)).fadeOut(200);
			}

			setTimeout(function() {
				_this.currentWord = _this.currentItem.description;
				let roleTemp;
				if(_this.mode == 1) {
					roleTemp = '高朗';
				} else {
					roleTemp = '方科科';
				}
				_this.currentRole = roleTemp;
				_this.conversationHistory.push({
					'role': roleTemp,
					'comment': _this.currentWord
				});
				_this.currentFakeWord = _this.currentWord;
				$('#talkBox2').fadeIn(200);
				if(_this.oldExpression != _this.currentExpression) {
					$(_this.getDomIdByExpression(_this.currentExpression)).fadeIn(200);
				}
				setTimeout(function() {
					_this.getLetterByLetter($('#talkBoxContent2'));
					setTimeout(function() {
						_this.step = 1.5;
						_this.clickable = true;
					}, 1000);
				}, 250);
			}, 500);
		} else if(this.step == 1.5) {
			this.clickable = false;
			if(this.currentRole == "高朗" || this.currentRole == "方科科") {
				this.showFullText($('#talkBoxContent2'));
			} else if(this.currentRole == "我") {
				this.showFullText($('#talkBoxContent1'));
			}
			setTimeout(function() {
				_this.step = 2;
				_this.clickable = true;
			}, 1000);
		} else if(this.step == 2) {
			this.clickable = false;
			$('#talkBox1').fadeOut(200);
			$('#talkBox2').fadeOut(200);
			$('#talkBoxContent1').text("");
			$('#talkBoxContent2').text("");
			this.currentHint = this.currentItem.directorComment;
			if(this.currentHint != '') {
				this.currentRole = "导师";
				this.currentWord = this.currentHint;
				setTimeout(function() {
					_this.currentFakeWord = _this.currentWord;
					$('#tutorHints').fadeIn(200);
					setTimeout(function() {
						_this.showFullText($('#tutorHintsContent'));
						setTimeout(function() {
							_this.step = 3;
							_this.clickable = true;
						}, 1000);
						_this.conversationHistory.push({
							'role': '导师点评',
							'comment': _this.currentWord
						});
					}, 250);
				}, 500);
			} else {
				this.currentOptions = this.currentItem.options.sort(function() {
					return 0.5 - Math.random();
				});
				if(this.currentOptions.length > 0) {
					setTimeout(function() {
						_this.step = 4;
						_this.clickable = false;
						_this.optionWrapShow = true;
						$(_this.getDomIdByExpression(_this.currentExpression)).fadeOut(200);
					}, 1000);
				} else {
					setTimeout(function() {
						_this.step = 5;
						_this.clickable = false;
						$('#generateReportBtn').fadeIn(200);
					}, 1000);
				}
			}
		} else if(this.step == 2.5) {
			this.clickable = false;
			if(this.currentRole == "高朗" || this.currentRole == "方科科") {
				this.showFullText($('#talkBoxContent2'));
			} else if(this.currentRole == "我") {
				this.showFullText($('#talkBoxContent1'));
			}
			setTimeout(function() {
				if(_this.currentRole == "高朗" || _this.currentRole == "方科科") {
					_this.step = 2
				} else if(_this.currentRole == "我") {
					_this.step = 1;
				}
				_this.clickable = true;
			}, 1000);
		} else if(this.step == 3) {

			this.clickable = false;
			$('#tutorHints').fadeOut(200);
			$('#tutorHintsContent').text("");
			this.currentOptions = this.currentItem.options.sort(function() {
				return 0.5 - Math.random();
			});
			if(this.currentOptions.length > 0) {
				setTimeout(function() {
					_this.step = 4;
					_this.clickable = false;
					_this.optionWrapShow = true;
					$(_this.getDomIdByExpression(_this.currentExpression)).fadeOut(200);
				}, 1000);
			} else {
				setTimeout(function() {
					_this.step = 5;
					_this.clickable = true;
					$('#generateReportBtn').fadeIn(200);
				}, 1000);
			}
		} else if(this.step == 11) {
			this.clickable = false;
			this.noticeShow = false;
			setTimeout(function() {
				$('#talkBack').fadeIn(200);
				_this.step = 12;
				_this.clickable = true;
			}, 1000);
		} else if(this.step == 12) {
			this.clickable = false;
			$('#talkBack').fadeOut(200);
			setTimeout(function() {
				$('#common').fadeIn(200);
				$('#introductionBox').fadeIn(200);
				_this.step = 13;
				_this.clickable = true;
			}, 1000);
		} else if(this.step == 13) {
			this.clickable = false;
			$('#introductionBox').fadeOut(200);
			this.currentRole = "我";
			setTimeout(function() {
				_this.currentFakeWord = _this.currentWord;
				_this.showSelfTalk();
				$('#reviewBtn2').fadeIn(200);
				setTimeout(function() {
					_this.getLetterByLetter($('#talkBoxContent1'));
					setTimeout(function() {
						_this.step = 2.5;
						_this.clickable = true;
					}, 1000);
				}, 250);
			}, 500);
			this.conversationHistory.push({
				'role': '我',
				'comment': this.currentWord
			});
		}
	}

	onOptionMouseDown(i, event) {
		if(this.optionClick == true || this.optionOnClick == true) {
			return false;
		}
		let _this = this,
			pressing = $(event.target).children('.pressing'), // 选项背景进度div
			pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
			pressingWidth = $(event.target).width(), // 选项宽度
			pressingHeight = $(event.target).height(), // 选项高度
			pressingOuterHeight = $(event.target).outerHeight(), // 选项真实高度, 包括margin, padding
			pressingOffset = $(event.target).offset(); // 选项在屏幕的位置

		// 按选项少于0.45s, 则不响应
		this.optionClick = false;
		this.optionOnClick = true;
		// 设置选项动画参数
		pressingOption.width(pressingWidth);
		pressingOption.height(pressingHeight);
		pressing.width(0);
		pressing.height(pressingOuterHeight),
			pressing.show();
		pressing.offset({
			top: pressingOffset.top,
			left: pressingOffset.left
		});
		// 选项背景动画
		pressing.animate({
			width: $(event.target)[0].clientWidth
		}, this.type ? 300 : 500, 'linear');
		// 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
		this.optionClickTimeout = setTimeout(function() {
			// 长按响应
			_this.optionClick = true;
			// 隐藏背景色
			pressing.animate({
				width: 0
			}, 1);
			pressing.hide();
			// 进入选中按钮动画
			$(event.target).addClass('optionLongPress');
			// 按键之后的动画
			$(event.target).find('.loading').fadeIn(200);
			_this.msgCharacter = 0;
			_this.currentRole = "我";
			_this.currentWord = _this.currentOptions[i].description;
			_this.conversationHistory.push({
				'role': '我',
				'comment': _this.currentWord
			});
			// 隐藏文字
			// 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
			_this.currentOptions[i].description = "";
			$('.optionItem').not($(event.target)).fadeOut(2500);
			// 保持选中按钮动画2s, 跳转动画
			setTimeout(function() {
				// 移出按钮动画
				$(event.target).removeClass('optionLongPress');
				_this.step = 2.5;
				_this.apiService.answerExerciseQuestion("" + _this.currentCaseId + "", _this.currentItem.id, _this.currentOptions[i].id).subscribe(practice => {});

				//全局缓存最后提交数据
				let exerciseConfig = {
					questionId: _this.currentItem.id,
					optionId: _this.currentOptions[i].id,
					exercisesId: _this.currentCaseId
				};
				window["exercises" + _this.currentCaseId] = exerciseConfig;

				_this.nextQuestionId = _this.currentOptions[i].nextQuestionId;
				_this.setCurrentItem(_this.nextQuestionId);
				_this.optionWrapShow = false;
				setTimeout(function() {
					_this.currentFakeWord = _this.currentWord;
					_this.showSelfTalk();
					setTimeout(function() {
						_this.getLetterByLetter($('#talkBoxContent1'));
						setTimeout(function() {
							_this.clickable = true;
							_this.optionClick = false;
						}, 750);
					}, 250);
				}, 500);
			}, 2000); // end of second setTimeout
		}, 450); // end of first setTimeout

	} //end of onOptionMouseDown

	onOptionMouseUp(event) {
		this.optionOnClick = true;
    setTimeout(()=>{
      this.optionOnClick = false;
    },300);
		// 如果已经触发按钮事件, 忽略放松按钮行为
		if(this.optionClick == true) {
			return true;
		}
		let pressing = $(event.target).children('.pressing');
		// 调整宽度为0
    setTimeout(()=>{
      clearTimeout(this.optionClickTimeout);
      pressing.stop().animate({
        width: 0
      }, 300, 'linear');
    },this.type ? 300 : 0);

	}

	discussionBgClick($event) {
		$event.stopPropagation();
		this.discussionBgMainMode = (this.discussionBgMainMode + 1) % 2;
	}

	reviewConversation($event) {
		$event.stopPropagation();
		$('#shade').fadeIn(50);
		$('#reviewBox').fadeIn();
		$('#closeBtn').fadeIn();
		this.clickable = false;
	}

	taskBookOut($event) {
		$event.stopPropagation();
		$('#shade').fadeIn(50);
		$('#taskBookBox').fadeIn();
		$('#closeBtn').fadeIn();
		this.clickable = false;
	}

	closeTip($event) {

		$event.stopPropagation();
		$('#shade').fadeOut();
		$('#reviewBox').fadeOut();
		$('#taskBookBox').fadeOut();
		$('#closeBtn').fadeOut();
		// 恢复点击功能
		this.clickable = true;
	}

	setCurrentItem(questionId) {
		let _this = this;
		this.questions.forEach(function(item, index) {
			if(item.id == questionId) {
				_this.currentItem = item;
				return;
			}
		});
	}

	setItemTemp(questionId) {
		let _this = this;
		this.questions.forEach(function(item, index) {
			if(item.id == questionId) {
				_this.oldItemTemp = _this.itemTemp;
				_this.oldOptionIndexTemp = _this.optionIndexTemp;
				_this.itemTemp = item;
				return;
			}
		});
	}

	getSelectedOptionIndex(options) {
		let temp = -1;
		options.forEach(function(item, index) {
			if(item.selected) {
				temp = index;
			}
		});
		return temp;
	}

	getDomIdByExpression(expression) {
		if(this.mode == 1) {
			if(expression == '叙述') {
				return '#narration';
			} else if(expression == '开心') {
				return '#happy';
			} else if(expression == '担心') {
				return '#worry';
			} else if(expression == '疑问') {
				return '#doubt';
			}
		} else {
			if(expression == '正常') {
				return '#common';
			} else if(expression == '皱眉') {
				return '#frown';
			} else if(expression == '得意') {
				return '#proud';
			} else if(expression == '挑眉') {
				return '#eyebrow';
			} else if(expression == '滴汗') {
				return '#sweat';
			} else if(expression == '生气') {
				return '#angry';
			}
		}
	}

	linkToReport() {
		this.apiService.finishExercise("" + this.currentCaseId + "").subscribe(practice => {
			if($('#learningPathMetaIdContainer').val() == 11){
				this.apiService.getReportKas(this.exerciseId,this.practiceId).subscribe((result)=>{
					console.log(111111,result)
					if(result){
					  this.apiService.getLevelInfo(result.reports[0]);
					}
				})
			}else if($('#learningPathMetaIdContainer').val() == 14){
				this.apiService.getKasInfos(this.exerciseId,this.practiceId).subscribe((result)=>{
					console.log(111111,result)
					if(result){
					  this.apiService.getLevelInfo(result.reports[0]);
					}
				})
			}


			// this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
					let link = ['case-practice-report-new', this.practiceId, this.exerciseId, this.learningPathId];
			if(this.type){
				this.router.navigate(link,{queryParams:{type:'huatek'}});
			}else{
				this.router.navigate(link);
			}
		});
		const exerciseMetaId=$('#exerciseMetaId').val()
		this.apiService.learingTime({learningPathMetaId:$('#learningPathMetaIdContainer').val(),module:'情景模拟',courseUnit:'',type:2,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
			console.log(result)
		})
		console.log(exerciseMetaId)
		this.commonService.sendPostMessage(2,'isPractice' +'Complete')
	}

	getLetterByLetter(container) {
		let _this = this;
		//对话显示全
		//_this.msgCharacter = _this.currentWord.length -1;
		this.msgTimeout = setTimeout(function() {
			_this.msgCharacter++;
			var type = _this.currentWord.substring(0, _this.msgCharacter);
			container.html(type);
			_this.getLetterByLetter(container);
			if(_this.msgCharacter == _this.currentWord.length) {
				if(_this.currentRole == "高朗" || _this.currentRole == "方科科") {
					_this.step = 2
				} else if(_this.currentRole == "我") {
					if(_this.step == 2.5) {
						_this.step = 1;
					} else if(_this.step == 1.5) {
						_this.step = 2;
					}
				}
				clearTimeout(_this.msgTimeout);
			}
		}, 30); // end of setTimeout
	} // end of getLetterByLetter

	showFullText(container) {
		clearTimeout(this.msgTimeout);
		container.html(this.currentWord);
	}

	showSelfTalk() {
		$('#talkBox1').fadeIn(200);
		$(this.getDomIdByExpression(this.oldExpression)).fadeOut(200);
		if(!this.oldExpression) {
			$(this.getDomIdByExpression(this.currentExpression)).fadeOut(200);
		}
	}
	closeSelfTalk() {
		$('#talkBox1').fadeOut(200);
		$(this.getDomIdByExpression(this.currentExpression)).fadeIn(200);
	}

}



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-main/case-practice-authorization-main.component.ts